import React from "react"
import IRSLogo from "../Icons/IRSLogo"
import Link from "../Links"

/**
 * IRS Footer
 * @returns {node} The rendered DOM node
 */
 const Footer = ({children, footerLinks, ...props }) => {

  const footerLinksGroup = footerLinks.map(({ href, key, text, external }) =>
    <li key={key} className="footerLink md:ml-2 mt-0 mb-4 md:my-3 md:my-0 h-5">
      <Link
        className="inline-block md:border-r md:pr-2 hover:underline"
        external={external}
        href={href}>
          {text}
      </Link>
    </li>
  )
  
  return (
    <footer className="footer mt-auto" {...props}>
      {children}
      <div className="text-white bg-black">
        <div className="container">
          <div className="flex flex-col md:flex-row text-center">
            <a href="https://www.irs.gov/">
              <IRSLogo className="h-7 block mx-auto my-5 md:my-3 text-white md:-ml-3" focusable={false}/>
            </a>
            <ul className="md:flex flex-grow md:justify-end mt-0 mb-2 md:mb-0 md:mt-1 text-center">
              {footerLinksGroup}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
